// Blog content loader for react-snap pre-rendering compatibility

const blogContentCache = {};

/**
 * Check if we're in react-snap pre-render environment
 */
export const isPrerendering = () => {
    return navigator.userAgent === 'ReactSnap';
};

/**
 * Load blog content asynchronously
 * Works in both pre-render and browser environments
 */
export const loadBlogContent = async (locale) => {
    // Return cached content if available
    if (blogContentCache[locale]) {
        return blogContentCache[locale];
    }
    
    try {
        const response = await fetch(`/lang/blog/cognitive-skills-${locale}.json`);
        
        if (!response.ok) {
            // Fallback to English
            const fallbackResponse = await fetch('/lang/blog/cognitive-skills-en.json');
            const data = await fallbackResponse.json();
            blogContentCache[locale] = data;
            return data;
        }
        
        const data = await response.json();
        blogContentCache[locale] = data;
        return data;
    } catch (error) {
        console.error('Error loading blog content:', error);
        
        // Return fallback structure
        return {
            title: 'Blog Post',
            metaDescription: 'Blog content',
            intro: { p1: '', p2: '', p3: '' },
            sections: {
                potential: { heading: '', p1: '', p2: '', p3: '' },
                typing: { heading: '', p1: '', p2: '', list: [], p3: '', p4: '' },
                metrics: { heading: '', p1: '', p2: '', list: [], p3: '' },
                tools: { heading: '', p1: '', p2: '', p3: '' },
                agency: { heading: '', p1: '', p2: '', quote: '', p3: '', p4: '' }
            },
            cta: { label: '', linkText: '' },
            copyright: ''
        };
    }
};
